import { ACTIVE_SERVER_ID } from 'mk/settings';
import { ajax_privacy_leaflet_accept_url } from 'mk/urls/functions';
import { about_privacy_and_cookie_policy_pattern } from 'mk/urls/patterns';
import * as strollersUrls from 'mk2/apps/strollers/urls';
import {
    PRIVACY_LEAFLET_ACCEPT_TRIGGER,
    privacyLeafletAcceptApi,
    PrivacyLeafletAcceptNormalizedResponse,
    PrivacyLeafletAcceptTriggerAction,
} from 'mk2/containers/PrivacyReminder/PrivacyReminder.actions';
import { handleXHRGetErrorSaga, normalizeError, XHRAction, XHRGetError } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { getRoutingLocation } from 'mk2/selectors';
import { redirectInPWASaga } from 'mk2/services/browserHistory';
import { normalize } from 'normalizr';
import { parse } from 'query-string';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';

const logger = getLogger('PrivacyLeafletAccept.sagas');

interface ApiResponseToPrivacyLeafletAccept {
    body: {};
}

function* privacyLeafletAccept({ xhr }: PrivacyLeafletAcceptTriggerAction & XHRAction) {
    yield put(privacyLeafletAcceptApi.request());
    try {
        const response: ApiResponseToPrivacyLeafletAccept = yield call(
            () => xhr.post(ajax_privacy_leaflet_accept_url(), {}),
        );
        const normalizedResponse: PrivacyLeafletAcceptNormalizedResponse = normalize(response.body, {});
        yield put(privacyLeafletAcceptApi.success(normalizedResponse));
        if (ACTIVE_SERVER_ID === 207) {
            const location = yield select(getRoutingLocation);
            if (location.pathname === about_privacy_and_cookie_policy_pattern) {
                let gotoUrl = strollersUrls.strollers;
                if (location.search && parse(location.search).next) {
                    const redirectTo = decodeURIComponent(parse(location.search).next);
                    gotoUrl = redirectTo ? redirectTo : gotoUrl;
                }
                yield redirectInPWASaga(gotoUrl);
            }
        }
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(privacyLeafletAcceptApi.failure(normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeLatest(PRIVACY_LEAFLET_ACCEPT_TRIGGER, privacyLeafletAccept),
    ]);
}
